import { render } from "./DiscardChangesModal.vue?vue&type=template&id=31899780&scoped=true"
import script from "./DiscardChangesModal.vue?vue&type=script&lang=js"
export * from "./DiscardChangesModal.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "./DiscardChangesModal.vue?vue&type=style&index=1&id=31899780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31899780"]])

export default __exports__